import { render, staticRenderFns } from "./auth-base-password-reset.vue?vue&type=template&id=a07305c2&scoped=true&"
import script from "./auth-base-password-reset.vue?vue&type=script&lang=ts&"
export * from "./auth-base-password-reset.vue?vue&type=script&lang=ts&"
import style0 from "./auth-base-password-reset.vue?vue&type=style&index=0&id=a07305c2&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a07305c2",
  null
  
)

export default component.exports